export const UPDATE_CLUSTER_DETAIL = "[CLUSTERS] UPDATE_CLUSTER_DETAIL";
export const UPDATE_EDIT_CLUSTER_DETAIL = "[CLUSTERS] UPDATE_EDIT_CLUSTER_DETAIL";
